export class FFDrawTeams {
  constructor({ animate, preview, update, animateOff }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.name = "FFDrawTeams";
    this.scene = "FF_Draw_Teams";
    this.data = [];
  }

  preview({ options }) {
    this.onAir = false;
    this.data = [];
    this.data.push({
      name: "Title",
      value: {
        text: options?.competition?.name || "",
      },
    });
    for (let i = 0; i <= 15; i++) {
      this.data.push({
        name: "Team_" + ( i + 1),
        value: {
          text:
            options?.selectedSeason?.teams?.[i]?.name || "",
        },
      });
    }
    this.sendPreview(this.scene, 500, this.data, "IN");
  }

  update({ options }) {
    this.data.push({
      name: "Title",
      value: {
        text: options?.competition?.name || "",
      },
    });
     for (let i = 0; i <= 15; i++) {
      this.data.push({
        name: "Team_" + ( i + 1),
        value: {
          text:
            options?.selectedSeason?.teams?.[i]?.name || "",
        },
      });
    }
    this.sendUpdate(this.scene, this.data);
  }
   animate({ options }) {
    this.onAir = true;

    this.sendAnimate(this.scene, this.data);
  }
   animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff(this.scene, []);
  }
}
